<template>
  <div class="">
    <v-layout row wrap>
      <v-flex lg12 md12>
        <v-container fluid>
          <!-- <v-form @submit.prevent="editMember()" ref="form" v-model="valid" lazy-validation> -->
          <v-form @submit.prevent="editMember()">
            <v-card flat>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Membership Type *"
                        v-model="member.member_setting"
                        @change="getResidence"
                        :items="allMemberSettings"
                        item-text="custom_name"
                        :return-object="true"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Residency *"
                        v-model="member.residence"
                        @change="getResidence"
                        :items="allResidenceTypes"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Type of Household"
                        v-model="member.household_type"
                        :items="allHouseHoldTypes"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <br />
            <v-card flat>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Member ID"
                        v-model="member.member_id"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'"
                    ><v-container>
                      <v-text-field
                        label="Salesforce ID"
                        v-model="member.salesforce_id"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-dialog
                        ref="dialog2"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Membership Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog2.save(member.expiry_date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container></v-flex
                  >
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-select
                        label="Title"
                        v-model="member.title"
                        :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                        :rules="[(v) => !!v || 'Title method is required']"
                        required
                        :loading="$loadingTrue"
                      ></v-select> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.first_name"
                        :rules="requiredRules"
                        label="First Name"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.sur_name"
                        :rules="requiredRules"
                        label="Last Name"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-select
                        label="Gender"
                        v-model="member.gender_id"
                        :items="allGender"
                        :rules="[(v) => !!v || 'Gender is required']"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                      ></v-select> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.dob"
                      >
                        <v-text-field
                          slot="activator"
                          label="Date of Birth"
                          v-model="member.dob"
                          :rules="requiredRules"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="member.dob"
                          :max="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(member.dob)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container></v-flex
                  >
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.id_alien_number"
                        label="ID Number/Alien ID (Required for every visit)"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.postal_address"
                        :rules="requiredRules"
                        label="Postal Address"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.postal_code"
                        :rules="requiredRules"
                        label="Postal Code"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.email"
                        :rules="requiredRules"
                        label="Email"
                        required
                        type="email"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg3 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country"
                        v-model="member.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        @change="findCountryCode"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.tel_number"
                        :rules="requiredRules"
                        label="Phone Number (e.g. +XXX...)"
                        required
                        minlength="13"
                        type="text"
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.member_id"
                        :rules="requiredRules"
                        label="MembershipID"
                        required
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4>
                    <v-container>
                      <v-select
                        label="Payment Method"
                        v-model="member.payment_method"
                        :items="[
                          'Mpesa',
                          'Credit Card',
                          'Bank Transfer',
                          'Cheque',
                          'Voucher',
                        ]"
                        required
                        :loading="$loadingTrue"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4>
                    <v-container>
                      <v-dialog
                        ref="dialogED"
                        persistent
                        v-model="modalED"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modalED = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialogED.save(member.expiry_date)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.salesforce_account_uuid"
                        :rules="requiredRules"
                        label="Salesforce Account ID"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.salesforce_contact_uuid"
                        :rules="requiredRules"
                        label="Salesforce Contact ID"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                  <v-flex lg4 md4 sm12 xs12
                    ><v-container>
                      <v-text-field
                        v-model="member.salesforce_uuid"
                        :rules="requiredRules"
                        label="Salesforce Opportunity ID"
                        required
                      ></v-text-field> </v-container
                  ></v-flex>
                </v-layout>
                {{ updateMember }}
              </v-container>
            </v-card>
            <br />
            <v-container>
              <v-switch
                color="primary"
                label="Is Paid"
                v-model="member.payment_status"
                required
              ></v-switch>
            </v-container>
            <v-btn
              :depressed="true"
              color="primary"
              type="submit"
              block
              large
              :loading="$loadingTrue"
              >Update Info</v-btn
            >

            <!-- <v-btn :depressed="true" large color="warning" block type="submit" >Update Info</v-btn> -->
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "EditMember",
  data() {
    return {
      start_date: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      menu1: false,
      modal1: false,
      modal2: false,
      dialogED: false,
      modalED: false,
      dob_config: {
        maxDate: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      },
      dob_config2: {
        maxDate: "today",
      },
      member: {
        public_id: this.$route.params.member_id,
        member_id: "",
        salesforce_uuid: "",
        salesforce_account_uuid: "",
        salesforce_contact_uuid: "",
        payment_status: false,
        expiry_date: "",
        member_setting: "",
        registration_type: "76f0a89",
        title: "",
        first_name: "",
        sur_name: "",
        email: "",
        code: "",
        payment_method: "",
        tel_number: "",
        registration_date: "",
        member_id: "",
        postal_address: "",
        id_alien_number: "",
        gender_id: "",
        postal_code: "",
        dob: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
        residence: "",
        household_type: "",
        children: "",
        promo_code: "",
        family: [],
        town: "",
        redirect_url: "Member",
      },
      residence: {},
      existing_member: false,
      household: false,
    };
  },
  created() {
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_membership_settings");
    this.$store.dispatch("get_all_genders");
    this.$store.dispatch("get_all_residence_types");
    this.$store.dispatch("get_all_house_holds");
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.member.tel_number = "+" + country.calling_code;
        }
      });
    },
    getResidence: function (data) {
      this.residence = data;
      this.member.member_setting = this.residence.public_id;
      this.$store.commit("GET_LOCAL_MEMBERS", this.residence);
    },
    editMember() {
      this.$store.dispatch("update_member", this.member);
    },
  },
};
</script>

<style scoped>
</style>
